<template>
  <div>
    <Head :title="'Registrar Pago - ' + client.name" />

    <!-- Header y Barra de herramientas -->
    <app-toolbar 
      name="Registrar Pago" 
      namePlural="Pagos" 
      :backHref="`/clients/${client.id}`"
      :hiddenCreate="true"
    />

        <!-- Registro de pagos -->
        <div class="bg-white rounded-lg shadow-sm mb-6">
      <div class="flex items-center px-6 py-4 bg-teal-800 text-white rounded-t-lg">
        <h2 class="text-lg font-semibold">Registrar pagos</h2>
      </div>

      <div class="p-6 bg-gray-50 border-b">
        <div class="flex items-center justify-between">
          <div>
            <h3 class="text-lg font-medium text-gray-900">Saldo pendiente</h3>
            <p class="text-2xl font-bold text-red-600">{{ formatCurrency(balanceTotal) }}</p>
          </div>
          <div class="text-right">
            <h3 class="text-lg font-medium text-gray-900">Cliente</h3>
            <p class="text-xl font-semibold text-gray-700">{{ client.name }}</p>
          </div>
        </div>
      </div>
      
      <div class="p-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label class="block text-gray-700 mb-2">Método de pago</label>
            <select 
              v-model="pay.method" 
              class="form-select w-full rounded-lg border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            >
              <option value="">Seleccionar método</option>
              <option 
                v-for="method in payment_methods" 
                :key="method.id" 
                :value="method.name"
              >
                {{ method.name }}
              </option>
            </select>
          </div>

          <text-input 
            v-model="pay.amount" 
            type="number" 
            step="0.10" 
            :error="pay.errors.long" 
            label="Monto" 
          />

          <text-input 
            v-if="['transferencia', 'transferencia-usd', 'zelle', 'pago-movil'].includes(pay.method)"
            v-model="pay.reference" 
            :error="pay.errors.reference" 
            label="Referencia" 
          />

          <div>
            <label class="block text-gray-700 mb-2">Fecha</label>
            <input 
              v-model="pay.date" 
              type="date"
              class="form-input w-full rounded-lg border-gray-300 focus:border-blue-500 focus:ring-blue-500" 
            />
          </div>
        </div>

        <div class="mt-6">
          <button 
            @click="storePay" 
            class="px-4 py-2 bg-teal-800 hover:bg-teal-900 text-white font-medium rounded-lg transition-colors"
          >
            Agregar pago
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import AppToolbar from '@/Shared/AppToolbar.vue'
import { formatCurrency } from '@/utils/format'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  name: 'ClientPaymentCreate',

  components: {
    Head,
    Link,
    AppToolbar,
    TextInput,
    SelectInput,
    LoadingButton,
  },

  layout: Layout,

  props: {
    client: Object,
    balanceTotal: Number,
    payment_methods: Object,
  },

  data() {
    return {
      pay: this.$inertia.form({
        client_id: this.client.id,
        method: '',
        amount: 0,
        reference: '',
        date: '',
      }),
    }
  },

  methods: {
    formatCurrency,
    submit() {
      this.$inertia.post(`/clients/${this.client.id}/payments`, this.form)
    },
    storePay() {
      this.pay.post('/payments')
    },
  },
}
</script> 